import styled from '@emotion/styled';
import { theme } from 'styles@emotion/theme';

const Spacer = styled.div`
  margin-left: ${({ vertical, size }) => (vertical ? `${size}px` : 0)};
  margin-bottom: ${({ horizontal, size }) => (horizontal ? `${size}px` : 0)};
`;

export default Spacer;
